import i18n from '@/i18n';

export default {
  actions: {
    update_lang({ commit }, lang) {
      commit('UPDATE_LANG', lang);
    },
    update_flag({ commit }, flag) {
      commit('UPDATE_FLAG', flag);
    },
  },
  mutations: {
    INIT_LANG(state) {
      try {
        const saved = localStorage.getItem('app-locale');
        if (saved) {
          const flag = localStorage.getItem('app-flag') || saved;
          this.commit('UPDATE_LANG', saved);
          this.commit('UPDATE_FLAG', flag);
        } else {
          this.commit('UPDATE_LANG', state.origin_lang);
          this.commit('UPDATE_FLAG', state.flag);
        }
      } catch (e) {
        this.commit('UPDATE_LANG', state.origin_lang);
      }
    },
    UPDATE_LANG(state, lang) {
      try {
        localStorage.setItem('app-locale', lang);
        i18n.global.locale = lang;
      } catch (e) {
        i18n.global.locale = lang;
      }
      state.lang = lang;
    },
    UPDATE_FLAG(state, flag) {
      try {
        localStorage.setItem('app-flag', flag);
        state.flag = flag;
      } catch (e) {
        state.flag = flag;
      }
    },
  },
  getters: {
    get_lang: state => state.lang,
    get_flag: state => state.flag,
    get_languages: state => state.languages,
  },
  state: {
    lang: 'en',
    flag: 'en',
    origin_lang: 'en',
    languages: [
      {
        dataLang: 'lv',
        imgSuffix: 'lv',
        name: 'Latviešu',
      },
      {
        dataLang: 'sv',
        imgSuffix: 'sv',
        name: 'Svenska',
      },
      {
        dataLang: 'az',
        imgSuffix: 'az',
        name: 'Azərbaycan',
      },
      {
        dataLang: 'pt',
        imgSuffix: 'bras',
        name: 'Brasileiro',
      },
      {
        dataLang: 'de',
        imgSuffix: 'de',
        name: 'Deutsch',
      },
      {
        dataLang: 'hy',
        imgSuffix: 'hy',
        name: 'Hայերեն',
      },
      {
        dataLang: 'en',
        imgSuffix: 'usa',
        name: 'American',
      },
      {
        dataLang: 'et',
        imgSuffix: 'et',
        name: 'Eestlane',
      },
      {
        dataLang: 'da',
        imgSuffix: 'da',
        name: 'Dansk',
      },
      {
        dataLang: 'pt',
        imgSuffix: 'pt',
        name: 'Português',
      },
      {
        dataLang: 'uk',
        imgSuffix: 'uk',
        name: 'Українська',
      },
      {
        dataLang: 'fr',
        imgSuffix: 'fr',
        name: 'Français',
      },
      {
        dataLang: 'es',
        imgSuffix: 'es',
        name: 'Español',
      },
      {
        dataLang: 'pl',
        imgSuffix: 'pl',
        name: 'Polski',
      },
      {
        dataLang: 'ja',
        imgSuffix: 'ja',
        name: '日本語',
      },
      {
        dataLang: 'el',
        imgSuffix: 'el',
        name: 'Ελληνικά',
      },
      {
        dataLang: 'cs',
        imgSuffix: 'cs',
        name: 'Češka',
      },
      {
        dataLang: 'ko',
        imgSuffix: 'ko',
        name: '한국어',
      },
      {
        dataLang: 'ru',
        imgSuffix: 'ru',
        name: 'Русский',
      },
      {
        dataLang: 'tr',
        imgSuffix: 'tr',
        name: 'Türk',
      },
      {
        dataLang: 'zh',
        imgSuffix: 'zh',
        name: '中文',
      },
      {
        dataLang: 'en',
        imgSuffix: 'en',
        name: 'English',
        classList: 'hint__item_rr',
      },
      {
        dataLang: 'lt',
        imgSuffix: 'lt',
        name: 'Lietuvos',
      },
      {
        dataLang: 'no',
        imgSuffix: 'no',
        name: 'Norsk',
        classList: 'hint__item_rl',
      },
    ],
  },
};
